(() => {
  'use strict';

  function waitForPeerNest(
    callback,
    attempt = 0
  ) {
    if (window.PeerNestDB) {
      callback();
      return;
    }

    if (attempt >= 80) {
      console.error(
        '[PeerNest Contact] Auth client unavailable.'
      );
      return;
    }

    setTimeout(
      () => waitForPeerNest(
        callback,
        attempt + 1
      ),
      100
    );
  }


  async function init() {
    const form =
      document.getElementById(
        'PeerNestContactForm'
      );

    if (!form) {
      return;
    }

    const email =
      form.querySelector(
        '#pncrEmail'
      );

    const button =
      form.querySelector(
        '.pncr-submit'
      );

    const loginNote =
      form.querySelector(
        '[data-pncr-login-required]'
      );


    const loginLink =
      form.querySelector(
        '[data-pncr-login-link]'
      );


    if (
      !email ||
      !button ||
      !loginNote ||
      !loginLink
    ) {
      console.error(
        '[PeerNest Contact] Required form elements missing.'
      );
      return;
    }


    let authenticated =
      false;


    function contactLoginURL() {

      const currentParams =
        new URLSearchParams(
          window.location.search
        );


      const previewThemeId =
        currentParams.get(
          'preview_theme_id'
        );


      const contactParams =
        new URLSearchParams();


      if (previewThemeId) {

        contactParams.set(
          'preview_theme_id',
          previewThemeId
        );

      }


      const returnURL =
        '/pages/contact'
        + (
            contactParams.toString()
              ? '?'
                + contactParams.toString()
              : ''
          )
        + '#pncr-form';


      const loginParams =
        new URLSearchParams();


      loginParams.set(
        'next',
        returnURL
      );


      if (previewThemeId) {

        loginParams.set(
          'preview_theme_id',
          previewThemeId
        );

      }


      return (
        '/pages/login?'
        + loginParams.toString()
      );

    }


    function showLoggedOut() {
      authenticated =
        false;

      button.disabled =
        true;

      button.setAttribute(
        'aria-disabled',
        'true'
      );

      loginNote.hidden =
        false;

      /*
       * Keep the original form visible.
       * Only sending is blocked.
       */

      email.readOnly =
        false;

      email.removeAttribute(
        'readonly'
      );

      email.removeAttribute(
        'aria-readonly'
      );
    }


    function showLoggedIn(
      accountEmail
    ) {
      authenticated =
        true;

      button.disabled =
        false;

      button.setAttribute(
        'aria-disabled',
        'false'
      );

      loginNote.hidden =
        true;

      /*
       * Account email is authoritative.
       */

      email.value =
        accountEmail;

      email.readOnly =
        true;

      email.setAttribute(
        'readonly',
        ''
      );

      email.setAttribute(
        'aria-readonly',
        'true'
      );
    }


    async function refresh() {
      try {
        const session =
          await window.PeerNestDB
            .getSession();

        if (!session?.access_token) {
          showLoggedOut();
          return;
        }


        const user =
          await window.PeerNestDB
            .getCurrentUser();


        if (!user?.id) {
          showLoggedOut();
          return;
        }


        let accountEmail =
          String(
            user.email ||
            ''
          ).trim();


        /*
         * Profile fallback only if Auth user
         * didn't provide an email.
         */

        if (!accountEmail) {
          const profile =
            await window.PeerNestDB
              .getMyProfile();

          accountEmail =
            String(
              profile?.email ||
              ''
            ).trim();
        }


        if (!accountEmail) {
          showLoggedOut();
          return;
        }


        showLoggedIn(
          accountEmail
        );
      }
      catch (error) {
        console.error(
          '[PeerNest Contact] Auth check failed:',
          error
        );

        showLoggedOut();
      }
    }


    /*
     * Login CTA is a real button.
     * Route explicitly instead of relying on an anchor.
     */

    loginLink.addEventListener(
      'click',
      event => {

        event.preventDefault();
        event.stopPropagation();


        window.location.assign(
          contactLoginURL()
        );

      }
    );


    /*
     * Prevent Enter-key/native submission while logged out
     * even though the button is already disabled.
     */

    form.addEventListener(
      'submit',
      event => {
        if (authenticated) {
          return;
        }

        event.preventDefault();

        loginNote.hidden =
          false;
      }
    );


    document.addEventListener(
      'peernest:auth-changed',
      refresh
    );


    /*
     * Safe default while session is loading.
     */

    showLoggedOut();

    await refresh();
  }


  waitForPeerNest(
    init
  );
})();
